var map = {
	"./Discord-active.png": "oxTI",
	"./Discord.png": "0+E6",
	"./Facebook-active.png": "38lg",
	"./Facebook.png": "9KiP",
	"./Instagram-active.png": "Fu1O",
	"./Instagram.png": "yTxU",
	"./Naver-active.png": "Cilu",
	"./Naver.png": "Pcff",
	"./TikTok-active.png": "DYPS",
	"./TikTok.png": "Be6z",
	"./Twitch-active.png": "0sCr",
	"./Twitch.png": "DeIe",
	"./VK-active.png": "yykD",
	"./VK.png": "hh7S",
	"./X-active.png": "Isbn",
	"./X.png": "5UjG",
	"./YouTube-active.png": "PAym",
	"./YouTube.png": "LMyy",
	"./bg-shadow.png": "7keO",
	"./border-active.png": "e6r3",
	"./border.png": "bPrd",
	"./de/email.png": "jiVe",
	"./de/service.png": "aVa+",
	"./de/text-follow-us.png": "VCZD",
	"./de/title.png": "XQ6U",
	"./divider.png": "DhMF",
	"./email.png": "jXni",
	"./en/email.png": "auvx",
	"./en/service.png": "65wQ",
	"./en/text-follow-us.png": "GyoV",
	"./en/title.png": "J5jB",
	"./es/email.png": "xrWB",
	"./es/service.png": "PKdS",
	"./es/text-follow-us.png": "AQui",
	"./es/title.png": "rh3o",
	"./fr/email.png": "esa7",
	"./fr/service.png": "leYJ",
	"./fr/text-follow-us.png": "qiMo",
	"./fr/title.png": "+ynm",
	"./ja/email.png": "Lkph",
	"./ja/service.png": "YUIQ",
	"./ja/text-follow-us.png": "RssG",
	"./ja/title.png": "cvT4",
	"./ko/email.png": "nPk2",
	"./ko/service.png": "xCcN",
	"./ko/text-follow-us.png": "NFWs",
	"./ko/title.png": "Gmuh",
	"./pt/email.png": "u3QX",
	"./pt/service.png": "1opx",
	"./pt/text-follow-us.png": "x1sb",
	"./pt/title.png": "GQR9",
	"./ru/email.png": "s+ng",
	"./ru/service.png": "Lvxx",
	"./ru/text-follow-us.png": "vGpt",
	"./ru/title.png": "A69p",
	"./service.png": "sqPQ",
	"./text-follow-us.png": "yCY9",
	"./th/email.png": "ZT31",
	"./th/service.png": "KGVo",
	"./th/text-follow-us.png": "0LWy",
	"./th/title.png": "V2uN",
	"./title.png": "uj8U",
	"./zh-Hant/email.png": "2UaM",
	"./zh-Hant/service.png": "KelZ",
	"./zh-Hant/text-follow-us.png": "vIR5",
	"./zh-Hant/title.png": "pqd5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Cmwe";